import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_coach/products/$productId/automations",
)({
  component: Outlet,
  staticData: {
    getBreadcrumb({ params }) {
      return {
        id: "product-automations",
        labelTranslationKey: "automationsPage.title",
        href: `/products/${params.productId}/automations`,
      };
    },
  },
});
